const CreateBrandConstants = {
  TYPE_RESET: 'RESET',

};

export default CreateBrandConstants